import React from 'react'
import { Skeleton } from '@material-ui/lab'

const Loader = () => {
  return (
    <div className="p-10 mt-48 space-y-10">
      <Skeleton variant="rect" width="full" height={120} />
      <Skeleton variant="rect" width="full" height={90} />
      <Skeleton variant="rect" width="full" height={90} />
      <Skeleton variant="rect" width="full" height={90} />
    </div>
  )
}

export default Loader
